import { Api } from './Api';

const  ENPOINTS = {
    EtatDocument: 'etat-documents',
};

const getAll = signal => {
    return Api.get(ENPOINTS.EtatDocument, signal)
}

const getById = (id, signal) => {
    return Api.get(`${ENPOINTS.EtatDocument}/${id}`, signal);
}

const create = (payload, signal) => {
    return Api.post(ENPOINTS.EtatDocument, payload, signal)
}

const update = (id, payload, signal) => {
    return Api.put(`${ENPOINTS.EtatDocument}/${id}`, payload, signal)
}
const destroy = (id, signal) => {
    return Api.erase(`${ENPOINTS.EtatDocument}/${id}`, signal)
}

export const EtatDocumentService = {
    getAll,
    getById,
    create,
    update,
    destroy
}